export function setCookieBannerFocus() {
  const cookieBanner = document.querySelector('.evidon-banner');

  if (cookieBanner && cookieBanner instanceof HTMLElement) {
    // Increase z-index
    cookieBanner.style.zIndex = '2147483647'; // Ensure this value is higher than other elements
    cookieBanner.setAttribute('tabindex', '0');

    const anchorTags = cookieBanner.querySelectorAll('a');
    const buttonElements = cookieBanner.querySelectorAll('button');
    const anchorTagsAndButtons = [...Array.from(anchorTags), ...Array.from(buttonElements)];

    anchorTagsAndButtons.forEach(element => {
      element.addEventListener('focus', () => {
        setElementStyles(element);
      });
      element.addEventListener('blur', () => {
        clearElementStyles(element);
      });
    });
  }
}

function setElementStyles(element: HTMLElement): void {
  element.style.borderRadius = '4px';
  element.style.outline = '3px solid #280';
  element.style.outlineOffset = '2px';
}
function clearElementStyles(element: HTMLElement): void {
  element.style.borderRadius = '';
  element.style.outline = '';
  element.style.outlineOffset = '';
}
